// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"09ba591f","239":"e39fb35b","455":"55372804","846":"842a8ad0","974":"bab522b2","977":"240addac"}[chunkId] + ".chunk.js";
};